import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import { initAnalytics } from "@/lib/analytics";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileCTA from "@/components/MobileCTA";

export default function Layout({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    initAnalytics();
    const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pb-16 md:pb-0">{children}</main>
      <Footer />
      <MobileCTA />
      <Toaster position="top-center" richColors />
    </div>
  );
}
